import React, { useMemo } from "react";

import { colors } from "@zapalacorp/tokens";

import { Location } from "../../../../../models/marine.traffic";
import {
  CityCountryContainer,
  CityCountryLabel,
  CodeContainer,
  CodeLabel,
  LocationContainer,
  LocationContainerProps,
  PortContainer,
  PortLabel,
} from "./styles";

interface LocationLabelProps extends LocationContainerProps {
  location?: Location;
  active?: boolean;
  id?: string;
  portName?: string;
  isAirTracking?: boolean;
}

export const LocationLabel = ({
  location = {} as Location,
  alignItems,
  active,
  id,
  portName,
  isAirTracking = false,
}: LocationLabelProps) => {
  const { locationName: city, locationCountry: country, UNLocationCode: code } = location;
  const countryCode = useMemo(() => code?.slice(0, 2), [code]);
  const cityCode = useMemo(() => code?.slice(2, code?.length), [code]);
  const darkColor = useMemo(() => (active ? colors.brandBlue600 : colors.gray800), [active]);
  const lightColor = useMemo(() => (active ? colors.brandBlue400 : colors.gray600), [active]);

  return (
    <LocationContainer alignItems={alignItems} id={id}>
      <CityCountryContainer>
        <CityCountryLabel color={isAirTracking ? lightColor : darkColor}>
          {city}
          {isAirTracking ? "," : ""}
        </CityCountryLabel>
        <CityCountryLabel color={lightColor}>{country}</CityCountryLabel>
      </CityCountryContainer>
      {isAirTracking && (
        <PortContainer>
          <PortLabel color={darkColor}>{portName}</PortLabel>
        </PortContainer>
      )}
      <CodeContainer>
        <CodeLabel color={lightColor}>{countryCode}</CodeLabel>
        <CodeLabel color={darkColor}>{cityCode}</CodeLabel>
      </CodeContainer>
    </LocationContainer>
  );
};
